export function createConsentRuntime({cookieConsent, document, window}) {
    const config = document.querySelector('[data-consent-config]');
    const tagManagerId = config?.dataset.gtmId;
    const tagManagerUrl = config?.dataset.gtmUrl;
    const dataLayer = window.dataLayer = window.dataLayer || [];
    const gtag = window.gtag = window.gtag || function () { dataLayer.push(arguments); };
    let previousConsent = null;
    let tagManagerLoaded = false;

    gtag('consent', 'default', {
        ad_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied',
        analytics_storage: 'denied',
    });

    function readConsent() {
        return {
            analytics: cookieConsent.acceptedCategory('analytics'),
            marketing: cookieConsent.acceptedCategory('marketing'),
            support: cookieConsent.acceptedCategory('support'),
        };
    }

    function loadTagManager(consent) {
        if (tagManagerLoaded || !tagManagerId || !tagManagerUrl || !(consent.analytics || consent.marketing)) {
            return;
        }

        const source = new URL(tagManagerUrl);
        if (source.protocol !== 'https:') {
            return;
        }

        dataLayer.push({'gtm.start': Date.now(), event: 'gtm.js'});
        const script = document.createElement('script');
        script.async = true;
        script.src = `${source.href}?id=${encodeURIComponent(tagManagerId)}`;
        script.dataset.consentManaged = 'tag-manager';
        document.head.appendChild(script);
        tagManagerLoaded = true;
    }

    function loadSupportChat(consent) {
        const settings = document.querySelector('[data-consent-smartsupp]');
        if (!consent.support || !settings || window.smartsupp) {
            return;
        }

        window._smartsupp = window._smartsupp || {};
        window._smartsupp.key = settings.dataset.key;
        const smartsupp = window.smartsupp = function () { smartsupp._.push(arguments); };
        smartsupp._ = [];

        for (const [field, method] of [['name', 'name'], ['email', 'email'], ['phone', 'phone']]) {
            const value = settings.dataset[field];
            if (value) {
                smartsupp(method, value);
            }
        }

        const script = document.createElement('script');
        script.async = true;
        script.charset = 'utf-8';
        script.src = 'https://www.smartsuppchat.com/loader.js?';
        script.dataset.consentManaged = 'support-chat';
        document.head.appendChild(script);
    }

    function update() {
        const consent = readConsent();
        const revoked = previousConsent !== null && Object.keys(consent).some(category => previousConsent[category] && !consent[category]);

        gtag('consent', 'update', {
            ad_storage: consent.marketing ? 'granted' : 'denied',
            ad_user_data: consent.marketing ? 'granted' : 'denied',
            ad_personalization: consent.marketing ? 'granted' : 'denied',
            analytics_storage: consent.analytics ? 'granted' : 'denied',
        });

        loadTagManager(consent);
        loadSupportChat(consent);
        const pendingEvents = window.__gigaPracePendingEvents || [];
        window.__gigaPracePendingEvents = [];
        for (const event of pendingEvents) {
            queueMarketingEvent(event);
        }
        previousConsent = consent;
        return revoked;
    }

    function queueMarketingEvent(event) {
        const consent = readConsent();
        if (!(tagManagerLoaded && consent.analytics && consent.marketing) || !event || typeof event !== 'object') {
            return false;
        }

        dataLayer.push(event);
        return true;
    }

    return {update, queueMarketingEvent};
}
